import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import moment from 'moment'
import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'
import axios from 'axios'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import IconButton from '@material-ui/core/IconButton'
import Buttons from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import CloseIcon from '@material-ui/icons/Close'
import AccordionViewModal from './AccordionViewModal'
import './SimpleAccordion.css'
const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    padding: '0px',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    backgroundColor: '#ffffff',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 120,
    paddingLeft: '5px',
    paddingRight: '5px',
    '&$expanded': {
      minHeight: 125
    }
  },

  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary)

const AccordionDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiAccordionDetails)
export default class SimpleAccordion extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expanded: '',
      formatedData: props.data,
      showModal: false,
      modalData: null,
      expansionPanelOpen: false,
      contributors:null,
    }
    console.log('Accordion pros', this.state.formatedData)

    console.log('=========props data isss==========', this.props)
  }

  handleChange = panel => (event, expanded) => {
    console.log('expanded====', panel, expanded)
    this.setState({ expanded: expanded ? panel : false })
  }

  openModalInfo(dataIndex) {
    this.setState({
      showModal: true,
      modalData: this.state.formatedData[dataIndex]
    })
  }

  closeModalInfo() {
    this.setState({
      showModal: false
    })
  }

   transformString = (inputString, needType) => {
    // Split the string into two parts: main part and the trailing part
    const mainPart = inputString.slice(0, -4); // All characters except the last 4
    const trailingPart = inputString.slice(-4); // Last 4 characters
  
    // Get the delimiter based on the NeedType
    const addString = needType === 'HCFA' ? '_P' : needType === 'UB' ? '_I' : '';
  
    // Construct the final string
    return `${mainPart}-${trailingPart[0]}${addString}`;
  }
  

  openUrl=(id)=>{
    let request = {
      username: process.env.REACT_APP_TOKEN_USERNAME,
      password: process.env.REACT_APP_TOKEN_PASSWORD
    }
  
    axios.post(process.env.REACT_APP_TOKEN_API, {}, {
      auth: request,
      headers: { "Content-Type":"application/x-www-form-urlencoded"}
     }).then((response) => {
      let string = process.env.REACT_APP_EOS_API
      let modified_id = this.transformString(id);
      string = string.replace("id", modified_id);
      axios.get(string, {
        headers: {
          'x-api-key': process.env.REACT_APP_X_API_KEY,
          token: response.data.access_token
        }
      }).then(response => {
        if(response.data[0]){
          window.open(Object.keys(response.data[0]).map(k => response.data[0][k])[0])
      
        }else{
          this.setState({showModal:true, message:"No EOS data available. Please try again later."})
      
        }
      })
      
    })
  }



   setOpenpopups =(billkey) => {
    console.log(process.env.REACT_APP_TOKEN_USERNAME,'process.env.REACT_APP_TOKEN_USERNAME');
    
    let request = {
      username: process.env.REACT_APP_TOKEN_USERNAME,
      password: process.env.REACT_APP_TOKEN_PASSWORD
    }
    // setLoader(true);
    axios.post(process.env.REACT_APP_TOKEN_API, {}, {
      auth: request,
      headers: { "Content-Type":"application/x-www-form-urlencoded"}
     }).then((response) => {
      axios.get(`${process.env.REACT_APP_CONTRIBUTORS_API}${billkey}`, {
        headers: {
          'x-api-key': process.env.REACT_APP_X_API_KEY,
          token: response.data.access_token
        }
      }).then(response => {
        if(response.data){
          if(response.data.contributors.length>0){
          
            this.setState({contributors:response.data, openpopup:true})
          
          }else{
            this.setState({showModal:true, message:"No contribution data available. Please try again later."})
          
          }
        }else{
          this.setState({contributors:null, openpopup:false})
        }
      })
      
    })
  




  }  


  //--- To get updated props on loadMore Btn click
  componentWillReceiveProps(nextProps) {
    this.setState({ formatedData: nextProps.data })
  }

  getDate(date) {
    const isDateValid = moment(date)['_isValid']
    if (isDateValid) {
      return moment(date).format('MMMM D, YYYY')
    }
    return date
  }

  numberWithCommas(x) {
    if (x) {
      if (x.toString().startsWith('$')) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        return '$' + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    } else {
      return 'NA'
    }
  }

  floatconversion = x => {
    if (x) {
      if (x.toString().startsWith('$')) {
        let substr = x.substr(1, x.length)
        return (
          '$' +
          parseFloat(substr)
            .toFixed(2)
            .toString()
        )
      } else {
        return x.toFixed(2)
      }
    } else {
      return undefined
    }
  }

  render() {
    return (
      <div>
        {this.state.formatedData.map((data, index) => (
          <Accordion expanded={this.state.expanded === 'panel' + index} onChange={this.handleChange('panel' + index)}>
            <AccordionSummary
              //expandIcon={<KeyboardArrowRightIcon  style={{marginLeft:'-25px'}}/>}
              expandIcon={
                <ExpandMoreIcon
                  className="collapseIcon"
                  onClick={() => {
                    this.setState({
                      expansionPanelOpen: !this.state.expansionPanelOpen
                    })
                  }}
                />
              }
              aria-controls="panel1a-content"
              id="panel1a-header"
              className="panelSummary"
            >
              <Grid container>
                <Grid item xs={8} className="itemWrap">
                  <div className="Expense-Number221">{data.ExpenseNumberLabel}</div>
                  <div className="Expense-Number211">{data.ExpenseNumberVal}</div>
                </Grid>

                <Grid item xs={4} className="itemWrap">
                {(data.status == 'Paid' || data.status == 'Denied' || data.status == 'Issued')? (
                    <span className={'status_button Audit'}>FINAL</span>
                  ) : (
                    <span className={'status_button Logged'}>IN REVIEW</span>
                  )}
                </Grid>

                <Grid item xs={12} className="itemWrap">
                  <div className="Expense-Number221">{data.ProviderLabel}</div>
                  <div className="Expense-Number211">{data.ProviderVal}</div>
                </Grid>

                <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">{data.row7}</div>
                  <div className="Expense-Number211">{data.rowval7}</div>
                </Grid>
                <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">{data.PaidLabel}</div>
                  <div className="Expense-Number211">{data.PaidVal?data.PaidVal:"NA"}</div>
                </Grid>

                <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">{data.DateOfServiceLabel}</div>
                  <div className="Expense-Number211">
                    {this.getDate(data.DateOfServiceVal)}
                  </div>
                </Grid>

                <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">{data.ChargedLabel}</div>
                  <div className="Expense-Number211">
                    {/* {data.ChargedVal} */}
                    {this.numberWithCommas(this.floatconversion(Number(data.ChargedVal)))}
                  </div>
                </Grid>

                {/* <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">{data.row8}</div>
                  <div className="Expense-Number211">
                  {this.getDate(data.rowval8)}
                     
                      </div>

                </Grid> */}

                {/* <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">{data.PaidLabel}</div>
                  <div className="Expense-Number211">
                  
                    ${this.numberWithCommas(this.floatconversion(data.PaidVal))}
               
                    </div>

                </Grid> */}
              </Grid>
            </AccordionSummary>
            <AccordionDetails style={{ paddingLeft: '26px' }}>
              <Grid container>
                {/* <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">{data.MoreDetail.DateofServiceLabel}</div>
                  <div className="Expense-Number211">{data.MoreDetail.DateofServiceVal}</div>
                </Grid> */}
                {/* <Grid item xs={5} className="itemWrap">
                  <div className="Expense-Number221">{data.MoreDetail.ProviderNameLabel}</div>
                  <div className="Expense-Number211">{data.MoreDetail.ProviderNameVal}</div>
                </Grid> */}
                {/* {
                  data.MoreDetail.EOSLabel == "" || data.MoreDetail.EOSLabel == " "
                  ?null
                  : */}
                <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">{data.MoreDetail.paidDateLabel}</div>
                  <div className="Expense-Number211">{this.getDate(data.MoreDetail.paidDateVal)}</div>

                  {/* <div className="Expense-Number211 view_number" onClick={()=>this.openModalInfo(index)}>VIEW</div> */}
                </Grid>
                {/* } */}

                <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">{data.MoreDetail.RepricedAmountLabel}</div>
                  <div className="Expense-Number211">{data.MoreDetail.RepricedAmountVal}</div>
                </Grid>
                <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">{data.MoreDetail.MCPVLabel}</div>
                  <div className="Expense-Number211">{data.MoreDetail.MCVPValue}</div>
                </Grid>

                {/* <Grid item xs={5} className="itemWrap">
                  <div className="Expense-Number221">{data.MoreDetail.EligibleforSharingLabel}</div>
                  <div className="Expense-Number211">{data.MoreDetail.EligibleforSharingVal}</div>
                </Grid> */}

                {/* <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">{data.MoreDetail.NonShareableAmountLabel}</div>
                  <div className="Expense-Number211">{data.MoreDetail.NonShareableAmountVal}</div>
                </Grid> */}
                <Grid item xs={5} className="itemWrap">
                  <div className="Expense-Number221">{data.MoreDetail.MCPLabel}</div>
                  <div className="Expense-Number211">{data.MoreDetail.MCPvalue}</div>
                </Grid>

                <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">{data.MoreDetail.ShareableAmountLabel}</div>
                  <div className="Expense-Number211">{data.MoreDetail.ShareableAmountValue}</div>
                </Grid>
                <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">Explanation of Sharing (EOS)</div>
                  <div className="number-View-download" onClick={() =>this.openUrl(data.ExpenseNumberVal,data.claim_type)}>VIEW/DOWNLOAD</div>
                </Grid>
                <Grid item xs={6} className="itemWrap">
                  <div className="Expense-Number221">Your Community Sharing</div>
                  <div className="number-View-download" onClick={() =>this.setOpenpopups(data.ExpenseNumberVal)}>VIEW</div>
                </Grid>
{/* 
                <Grid item xs={5} className="itemWrap">
                  <div className="Expense-Number221">{data.MoreDetail.SharedByUHFLabel}</div>
                  <div className="Expense-Number211">{data.MoreDetail.SharedByUHFVal}</div>
                </Grid> */}
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))}

<Modal dialogClassName="my-modal" show={this.state.openpopup} onHide={()=>this.setState({openpopup: false})} centered className="ChangPayModal" backdrop="static">
          <Modal.Header style={{height:56, fontFamily:"Lato"}}>
          <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <h6 style={{color:"#373a3c"}}>Your Community Sharing</h6>
                <IconButton aria-label="close" style={{ marginTop: '-13px', marginRight:"-15px" }} onClick={() =>this.setState({openpopup: false, contributors:null})}>
                  <CloseIcon />
                </IconButton>
              </Grid>
          </Modal.Header>
          <Modal.Body>
            <div style={{padding:15}}> 
            <TableContainer  component={Paper}>
              <Table  sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow style={{borderBlockColor:"black"}}>
                    <TableCell style={{borderColor:"#8c827a"}}><p style={{width:"auto", marginTop:16, fontWeight:"normal", color: "#454d58", paddingLeft:10}}>Member</p></TableCell>
                    <TableCell align="right" style={{borderColor:"#8c827a"}}><p style={{width:"auto", marginTop:16,fontWeight:"normal", color: "#454d58", paddingRight:10}}>Contribution Amount</p></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody style={{maxHeight:173, overflowY: 'auto', display:'block', width:"214%"}}>
                
                  {this.state.contributors && this.state.contributors.contributors && this.state.contributors.contributors.map((res, i)=> <TableRow key={i}>
                      <TableCell align="left" style={{borderColor:this.state.contributors.contributors.length==i+1?"#8c827a":"", width:"123%"}}><p style={{width:"auto", marginTop:16, fontWeight:"500", color:"black", paddingLeft:10}}>{res.first_name[0]} {res.last_name[0]}</p></TableCell>
                      <TableCell align="right" style={{borderColor:this.state.contributors.contributors.length==i+1?"#8c827a":"", width:"123%"}}><p style={{width:"auto", marginTop:16, fontWeight:"500", color:"black", paddingRight:10}}>{res.contribution_amount}</p></TableCell>
                    </TableRow>)}
                  
                </TableBody>
                {this.state.contributors && 
                  <TableRow style={{backgroundColor:"#F6F6F6"}} key={"total"}>
                      <TableCell align="left"><p style={{width:"auto", marginTop:16, fontWeight:"500", color:"black", paddingLeft:10}}>Total Contribution</p></TableCell>
                      <TableCell align="right"><p style={{width:"auto", marginTop:16, fontWeight:"500", color:"black", paddingRight:10}}>{this.state.contributors.total_contributions}</p></TableCell>
                    </TableRow>}  
              </Table>
            </TableContainer>

            </div>
          </Modal.Body>
          <Modal.Footer>
          <Buttons variant="secondary" style={{ marginRight: '15px' }} 
                onClick={() => this.setState({openpopup: false, contributors:null})}
                class="reimbursement-ButtonBGsave">
                  CLOSE
                </Buttons>
          </Modal.Footer>
          </Modal>

        <Modal show={this.state.showModal}>
          <Modal.Header closeButton>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="ModalWrapper">
             <p>{this.state.message}</p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Buttons variant="secondary"   class="reimbursement-ButtonBGsave" onClick={() => this.setState({message:"", showModal:false})}>
              Close
            </Buttons>
         
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

const sampleData2 = [
  { id: 733, planId: '7006', idcardField: 'Telemedicine', fieldValue: '$0' },
  { id: 735, planId: '7006', idcardField: 'PCP Office Visit', fieldValue: '$35' },
  { id: 736, planId: '7006', idcardField: 'Urgent Care', fieldValue: '$100' },
  { id: 737, planId: '7006', idcardField: 'ER Visit', fieldValue: '$400' }
]
